<template>
    <div @contextmenu.capture.prevent="showMetricsOptions()" @mouseover="hoverCommentIndex = true" @mouseleave="hoverCommentIndex = null">
        <slot v-if="commentData.length > 0 && displayComments && editable == true">
            <div class="cursor-help w-2 h-2 rounded-full absolute bg-growth"></div>
        </slot>
        <slot v-if="selectedModel != null && editable == true">
            <input v-if="edit" 
                v-model="new_value"
                ref="editInput"
                @blur="updateMetrics()"
                @keyup.enter="updateMetrics()"
                class="text-black text-center bg-gray-200 border-textOnBkg dark:border-dark.sepBorder w-full" 
            />
            <section v-else>{{ signSymbol }} {{addSpace(displayData)}}</section>
            <section v-if="showOptions == true || addingComment" :style="'transform: translate3d('+optionPosition.x+'px,'+optionPosition.y+'px,0);'" 
                class="text-center text-sm leading-8 z-30 rounded absolute w-30 h-max bg-white border-gray-200 border dark:border-dark.sepBorder shadow-light dark:shadow-dark text-textOnBkg font-normal">
                <span v-if="showOptions" @mouseleave="showOptions = false">
                    <slot v-if="commentData[0]">
                        <div class="cursor-pointer hover:bg-gray-300 px-3 rounded" @click="resetComments(), removeComment(commentData[0].commentID,0)">
                            <font-awesome-icon icon="fas fa-trash-can" class="text-sm mr-1" /> {{ $t('delete_comment') }}
                        </div><hr />
                    </slot>
                    <slot v-else>
                        <div class="cursor-pointer hover:bg-gray-300 px-3 rounded" @click="addComment()">
                            <font-awesome-icon icon="fas fa-comment" class="mr-1" /> {{ $t('add_comment') }}
                        </div>
                        <hr />
                    </slot>
                    <div class="cursor-pointer hover:bg-gray-300 px-3 rounded" @click="startEdit()"><font-awesome-icon icon="fas fa-pen" class="text-sm mr-1" /> {{ $t('change_value') }}</div>
                </span>
                <div v-if="addingComment" class="text-left p-2">
                    <font-awesome-icon icon="fas fa-times" @click="resetComments()" class="cursor-pointer absolute right-0 top-0 p-2 text-textOnBkg" />
                    <input v-model="comment_value" :placeholder="$t('comment')" type="text" class="mr-5 text-left mb-2 border border-sepBorder dark:border-dark.sepBorder px-1 rounded" /><br />
                    <button @click="saveComment(column,date,selectedModel,ind)" class="bg-button text-white px-5 rounded mb-2 mr-1.5 -mt-3 ">
                        <font-awesome-icon icon="fas fa-floppy-disk" /> {{ $t('save') }}
                    </button>
                </div>
            </section>
        </slot>
        <slot v-else>
            <section>{{ signSymbol }} {{addSpace(displayData)}}</section>
        </slot>
        <metricsComment 
            v-if="displayComments && hoverCommentIndex && commentData && commentData[0]" 
            :data="[commentData,selectedModel,commentData]" />
    </div>
</template>

<script setup>
    import inputMetricsEdit from "@/components/inputMetricsEdit.vue"
    import metricsComment from "@/components/metrics/metricsComment.vue"
</script>

<script>
    import { updateMetrics_api_call } from "@/api/api.js";
    export default {
        props: ['editM','editValue','displayComments','signSymbol','editable','optionIndex','commentData','editData','column','date','selectedModel','optionPosition'],
        emits: ['changedData'],
        data() {
            return {
                addingComment: false,
                edit:false,
                showOptions:true,
                comment_value:this.commentData[0]?.value ?? "",
                hoverCommentIndex:null,
                changeIndex:0,
                new_value: this.editData,
                showOptions: false,                
                displayData: this.editData,
                updating: false,
            }
        },
        watch: {
            hideF(newVal) {
                this.localHideF = newVal;
            },
            editM(newVal) {
                this.localEditM = newVal;
            },
            editValue(newVal) {
                this.localEditValue = newVal;
            },
        },
        components() {metricsComment,inputMetricsEdit},
        methods: {
            addComment() {
                this.addingComment = true; 
                this.showOptions = false;
            },
            startEdit() {
                this.edit = true;
                this.new_value = this.displayData;
                this.showOptions = false,
                this.$nextTick(() => {
                    this.$refs.editInput.focus();
                });
            },
            showMetricsOptions() {
                if (this.editable) {
                    //this.hideF = true;
                    this.showOptions = true
                    this.optionPosition.x = pointerX+50;
                }
            },
            async removeComment(comment_id,index) {
                if (confirm("Are you sure you want to delete comment '" + this.comment_value + "'?")) {
                    let response = await updateMetrics_api_call({                    
                        action: "deleteMetricsComment",
                        commentID: comment_id,
                        userToken: this.$cookies.get('userToken'),
                        companyID: this.$cookies.get('c_id')
                    });
                    if (response) {
                        this.commentData.splice(index,1);
                    }
                }
            },
            updateHideF(value) {
                this.localHideF = value;
                this.$emit('update:hideF', value);  // This assumes `hideF` is set up as a v-model in the parent
            },
            updateEditM(value) {
                this.localEditM = value;
                this.$emit('update:editM', value);  // Emit changes to parent component if needed
            },
            updateEditValue(value) {
                this.localEditValue = value;
                this.$emit('update:editValue', value); // Emit changes to parent component if needed
            },
            async updateMetrics() {
                if (this.updating == true) {return;}
                
                this.updating = true;
                this.edit = false;

                this.new_value = parseFloat(String(this.new_value).replace(",","."));
                
                let response = await updateMetrics_api_call({
                    action: "updateMetrics",
                    Model_pair_id: this.selectedModel,
                    newValue: this.new_value,
                    column: this.column,
                    date: this.date,
                    userToken: this.$cookies.get('userToken'),
                    companyID: this.$cookies.get('c_id')
                });
                if (response) {
                    this.displayData = this.new_value;
                    setTimeout(() => {
                        this.updating = false;
                    }, 500);
                }
            },
            addSpace(nStr) {
                nStr += '';
                var x = nStr.split('.');
                var x1 = x[0];
                var x2 = x.length > 1 ? '.' + x[1] : '';
                var rgx = /(\d+)(\d{3})/;
                while (rgx.test(x1)) {
                    x1 = x1.replace(rgx, '$1' + " " + '$2');
                }
                return x1 + x2;
            },
            resetComments() {
                this.showOptions = false;
                this.addingComment = false;                
            },
            async saveComment(column,date,model,ind) {
                if (this.commentData && this.commentData.commentID) {
                    var commentID = this.commentData.commentID;
                } else {var commentID = null;}

                var row = this.$moment(date, "DD.MM.YYYY").format("YYYY-MM-DD");

                let response = await updateMetrics_api_call({                    
                    action: "addComment",
                    comment: this.comment_value,
                    commentID: commentID,
                    pair_ID: model,
                    column: column,
                    date: row,
                    userToken: this.$cookies.get('userToken'),
                    companyID: this.$cookies.get('c_id')
                });
                if (response) {
                    this.commentData[0] = {value: this.comment_value, commentID: result.data};
                    this.resetComments();
                    this.comment_value = null;
                }
            },
        },
    }
</script>